import { Button, Flex, Stack } from "@mantine/core";
import { useTranslation } from "react-i18next";
import style from "./precision.module.css";

import { IconArrowRight } from "@tabler/icons-react";
import { Link, useNavigate } from "react-router-dom";
import FalsePositivesChart from "./components/false-positives-chart";

const PrecisionSegment = () => {
    const { t } = useTranslation(["landing-page"]);
    const navigate = useNavigate();

    return (
        <div className={style.wrapper}>
            <div className={style.innerWrapper}>
                <div className={style.flex}>
                    <Stack className={style.leftWrapper} spacing={"0.5rem"} mt={"0rem"}>
                        <h2 className={style.header}>{t("precision-segment.title")}</h2>

                        <p className={style.text}>{t("precision-segment.description")}</p>

                        <Button
                            onClick={() => navigate("/precision")}
                            color="dark"
                            radius={"xl"}
                            variant="outline"
                            rightIcon={<IconArrowRight size={"1rem"} />}
                            w={"fit-content"}
                        >
                            {t("precision-segment.read_more")}
                        </Button>
                    </Stack>

                    <FalsePositivesChart />
                </div>
            </div>
        </div>
    );
};

export default PrecisionSegment;
